import styled from 'styled-components';

export const FlexColumn = styled.div`
	display: flex;
	flex-direction: column;
`;

export const Content = styled(FlexColumn)`
	margin-top: 12px;
	margin-bottom: 12px;
	gap: 20px;
	padding: 16px;
	background-color: ${({ theme }) => theme.gray['100']};
	border-radius: 8px;
`;

export const CheckboxContainer = styled.div`
	margin-top: -1px;
	margin-right: -1px;
	width: 20px;
	height: 20px;
`;

export const DropdownContainer = styled.div`
	width: 100px;
`;

export const Setting = styled.div`
	display: flex;
	flex-direction: row;
	gap: 12px;
	height: 20px;
`;

export const Spacer = styled.div`
	flex: 1;
`;

export const Label = styled.p`
	font-size: 12px;
	font-family: 'Inter', sans-serif;
	color: ${({ theme }) => theme.gray['1000']};
	margin-top: 2px;
	width: 280px;
`;

export const Choice = styled.div`
	// align contents to the right
	justify-content: flex-end;
`;
